/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  sendEventIntegrationEndpoint,
} from '@/api/microsservices/EventsApi';

import {
  middlewareEndpoint,
} from '@/api/microsservices/MiddlewareApi';

import IInteractEventTracker from '@/app/features/InteractEventTracker/entities/IInteractEventTracker';

export const sendEventIntegration = (payload: IInteractEventTracker) => {
  return sendEventIntegrationEndpoint.post(payload)
    .then(() => {
      if(payload.customer_id && payload.customer_id !== 'unlogged') {
        middlewareEndpoint.post(
          {
            instance_id: payload.customer_id,
            instance_type: 'USER',
            signal: 'USER',
            event_name: payload && payload.actions && payload.actions[0].action,
            event_description: payload && payload.actions && payload.actions[0].attributes && payload.actions[0].attributes.event_description,
            integration: null,
            related_instances: null,
            details: payload && payload.actions && payload.actions[0]
          }
        );
      }
    });
};

